import { ServiceMaker, methods, services } from ".";

export const sendResetPasswordRequest = payload =>
    ServiceMaker(
        `/cap/users/tenant/forgot-password`,
        methods.POST,
        services.master,
        payload
    );

export const resetPasswordTenant = payload =>
    ServiceMaker(
        `/cap/users/tenant/reset-password`,
        methods.POST,
        services.master,
        payload
    );